import { createGlobalStyle as e } from "styled-components";
//#region src/theme/GlobalStyles.ts
var t = e`
    *, *::before, *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    html {
        font-size: 16px;
        -webkit-text-size-adjust: 100%;
    }

    body {
        font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
        font-weight: ${({ theme: e }) => e.typographyTokens.weights.normal};
        line-height: ${({ theme: e }) => e.typographyTokens.lineHeights.normal};
        background-color: ${({ theme: e }) => e.colors.background};
        color: ${({ theme: e }) => e.colors.foreground};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        transition:
            background-color ${({ theme: e }) => e.transitions.normal},
            color ${({ theme: e }) => e.transitions.normal};
    }

    a {
        color: ${({ theme: e }) => e.colors.primary};
        text-decoration: none;
    }

    a:hover { text-decoration: underline; }

    /* Swap the whole tree to the Arabic face in RTL; form controls inherit it. */
    html[dir="rtl"] body {
        font-family: 'IBM Plex Sans Arabic', ${({ theme: e }) => e.typographyTokens.fontFamily};
    }

    button, input, select, textarea {
        font-family: inherit;
        font-size: inherit;
    }

    img, svg { display: block; max-width: 100%; }
    ul, ol { list-style: none; }
`;
//#endregion
export { t as GlobalStyles };
